import fastDeepQual from "fast-deep-equal";
export const deepEqual = fastDeepQual;
//# sourceMappingURL=deepEqual.js.map